import * as React from 'react';
import {BATCH_STAGE} from '../../Config/appConfig';
import {BatchRow} from '../../Config/dataModel';
import BatchRecordTableViewCell from './BatchRecordTableViewCell';

const collapse = require('../../resource/img/collapse-default.svg');

interface BatchRecordTableViewProps {
    stage: string,
    records: BatchRow[],
    title: string
}

interface BatchRecordTableViewState {
    collapse: boolean
}

class BatchRecordTableView extends React.Component <BatchRecordTableViewProps, BatchRecordTableViewState> {
    public constructor(props: BatchRecordTableViewProps) {
        super(props);
        this.state = {
            collapse: this.props.stage === BATCH_STAGE.VALID
        };
        this.clickCollapse = this.clickCollapse.bind(this);
    }

    public clickCollapse(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            collapse: !this.state.collapse
        });
    }

    public getRecords() {
        const cells = [];
        for (let i = 0; i < this.props.records.length; i++) {
            const data = this.props.records[i];
            cells.push(
                <BatchRecordTableViewCell
                    key={i}
                    stage={this.props.stage}
                    row={data.row}
                    actionCode={data.actionCode}
                    chassisNo={data.chassisNo}
                    issueNo={data.issueNo}
                    endDate={data.endDate}
                    errorMsgs={data.errorMsgs}/>);
        }
        return cells;
    }

    public render() {
        return (
            <div>
                <div className="batchRecordTableViewContainer">
                    <div className={`${this.props.stage === BATCH_STAGE.VALID ? "cmText" : "cmErrorText"} batchRecordTableViewTitle`}>{`${this.props.title}`}</div>
                    <button className={`${this.state.collapse ? "cmCollapse" : ""}`} onClick={this.clickCollapse}>
                        <img src={collapse}/>
                    </button>
                </div>
                {!this.state.collapse && this.getRecords()}
            </div>
        );
    }
}

export default BatchRecordTableView;


// WEBPACK FOOTER //
// ./src/Components/Batch/BatchRecordTableView.tsx